import styled from 'styled-components';

export const StyledModal = styled.div`
  @-webkit-keyframes slide-bottom {
    0% {
      -webkit-transform: translate(-50%, -100%);
              transform: translate(-50%, -100%);
    }
    100% {
      -webkit-transform: translate(-50%, 0);
              transform: translate(-50%, 0);
    }
  }
  @keyframes slide-bottom {
    0% {
      -webkit-transform: translate(-50%, -100%);
              transform: translate(-50%, -100%);
    }
    100% {
      -webkit-transform: translate(-50%, 0);
              transform: translate(-50%, 0);
    }
  }

  .overlay {
    background: rgba(0,0,0, 0.8);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
  }

  .content {
    position: fixed;
    top: 0;
    background: #fff;
    box-shadow: 0 0 15px rgba(0,0,0, 0.7);
    left: 50%;
    width: calc(100% - 20px);
    z-index: 9999;
    padding: 30px;
    border-radius: 0 0 ${props => props.theme.borderRadius} ${props => props.theme.borderRadius};
    -webkit-animation: slide-bottom 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation: slide-bottom 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    max-width: 550px;
  }

  .close {
    position: absolute;
    bottom: -70px;
    right: 0;
    z-index: 999;
    cursor: pointer;
    color: #fff;
    border-radius: 100%;
    display: flex;
    height: 50px;
    width: 50px;
    font-weight: bold;
    align-items: center;
    justify-content: center;
    font-size: 48px;
  }
`
